import { clsx } from 'clsx'

// Segmented control — in-screen view switch (e.g. Próximos / Pasados). Options
// meet the 48px touch target.
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  className,
}: {
  options: { value: T; label: string }[]
  value: T
  onChange: (value: T) => void
  className?: string
}) {
  return (
    <div
      role="tablist"
      className={clsx(
        'flex p-1 gap-1 rounded-[var(--radius)] bg-[var(--panel-2)] border border-[var(--line)]',
        className,
      )}
    >
      {options.map((opt) => {
        const selected = opt.value === value
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(opt.value)}
            className={clsx(
              'flex-1 min-h-[var(--tap)] rounded-[var(--radius-sm)] text-[length:var(--fs-sm)] font-semibold transition-colors',
              // Active = wash + accent text (the chip-active language) — a solid
              // accent fill made the switch the loudest block on the screen,
              // beating the real CTA (styleguide §3: one filled accent/screen).
              selected
                ? 'bg-[var(--accent-wash)] text-[color:var(--accent)] shadow-[inset_0_0_0_1px_var(--accent)]'
                : 'text-[color:var(--fg-muted)]',
            )}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
